<template>
  <div class="mt-4">
    <custom-callout :opened="true" class-panel="bg-white">
      <label class="title p-2">Resumen de Categoría</label>
      <template #edition>
        <div
          v-for="item in summary"
          :key="item.ageCategory"
          class="mt-3 p-3 bg-secondary-3"
        >
          <div class="row ">
            <div class="col-md-4">
              <p class="mt-3 ml-5 pl-md-2 font-14 item-description">
                {{ item.description }}
              </p>
            </div>
            <div class="col-sm">
              <p class="text-center font-14 font-weight-normal mb-0">
                Cantidad Actual
              </p>
              <p class="text-center mt-1">
                {{ item.currentQuantity }}
              </p>
            </div>
            <div class="col-md-4">
              <p class="text-center font-14 font-weight-normal mb-0">
                Cantidad del Año Anterior
              </p>
              <p class="text-center mt-1">
                {{ item.lastYearQuantity }}
              </p>
            </div>
            <div class="col-sm ">
              <p class="text-left">
                <span
                  :class="badgeClass(item.difference)"
                  class="rounded-pill  font-14 font-weight-normal text-light mt-1 mr-3 px-2 py-1 "
                >
                  {{ Math.round(item.difference) }}%
                </span>
              </p>
            </div>
          </div>
        </div>
      </template>
    </custom-callout>
  </div>
</template>
<script>
import CustomCallout from 'custom-callout'
export default {
  name: 'SummaryByCategory',
  components: { CustomCallout },
  props: {
    summary: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
    badgeClass(percent) {
      if (percent > 9) return 'bg-danger'

      return 'bg-success'
    },
  },
}
</script>
<style>
@media (max-width: 763px) {
  .item-description {
    text-align: center !important;
    padding: 0 !important;
    margin: 0 !important;
  }
}
</style>
